<template>
  <div>
  <table class="table-bordered table-hover tbl datatables" style="width:100%;">
    <thead class="thead-default tablehead">
      <tr>
        <th class="text-center">ShippingId</th>
        <th class="text-center">Pending Days</th>
        <th v-if="isCourierCompanyId" class="text-center">Agent Id</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item,index) in shortagePendingShipments" :key="index" class="text-center">
      <td>{{item.shippingid}}</td>
      <td>{{item.pendingdays}}</td>
      <td v-if="isCourierCompanyId">{{item.courierid}}</td>
      </tr>
    <tr v-if="shortagePendingShipments.length==0">
      <td colspan="35" align="center">No record found</td>
    </tr>
  </tbody>
  </table><br>
  </div>
</template>


<script>
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading'

export default{
  name: "shortageShipments",
  components: {
    Paginate,VueElementLoading
  },
  data:function(){
  return {
    pagecount:1,
    }
  },
  props: {
    shortagePendingShipments: {
      type: Array,
      required: true
    },
    isCourierCompanyId: {
      type: Boolean,
      // required:true
    }
  },
  methods:{

  }
}
</script>


<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/common/shortageShipments.vue?50d65e0d